module.exports = {
    "ApiUrl": "https://rm-api-ci2-ase-dev.icarehealth.com.au/api/",
    "IdentityServerAuthority": "https://rm-ci2-identity-ase-dev.icarehealth.com.au",
    "SignalRUrl": "https://rm-api-ci2-ase-dev.icarehealth.com.au/signalr",
    "AutomationEnabled": true,
    "MedicareTimeZone": "Australia/Melbourne"
};
